import ReactDOM from 'react-dom'
import React from 'react'
import 'ynf-core-middleware'; // 注入系统级异常捕获，勿删
import mobileInit from './mobile';
import LoadRes from './RuntimeView';
import 'core-js/stable';

const ynfReg = /\/fragment/
const bizFlowReg = /\/fragment\/pullvoucher/
let rootElement = document.getElementById('root')
// 如果是小程序file协议，要画到container容器里
if (window.location.href.startsWith('file://')) {
  rootElement = document.getElementById('container')
  if (!window.sessionStorage.getItem('yhtToken')) {
    mtl.getUserYHTInfo({ isEncrypt: false, success: (res) => { res && window.sessionStorage.setItem('yhtToken', res.yhtToken) } })
  }
}
mobileInit()
if (ynfReg.test(window.location.href)) {
  LoadRes(bizFlowReg.test(window.location.href)).then(RuntimeView => ReactDOM.render(<RuntimeView></RuntimeView>, rootElement))
}
